import React, { Component } from 'react'
import Input from './shared/Input';
import Button from './shared/Button';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import Loader from './shared/Loader'
import { profileLogin } from '../store/profile/actions'

import baseStyles from 'custom/base.styl';
import { get } from "lodash";
import classnames from "classnames";
import { clearToken } from './../utils/tokenStorage';
import { trackValues } from './../tracker';
import { trackSiteId } from './../config';

import { LoginPageTitle, LoginPageSubTitle } from 'custom/LoginPageText';


class PageLogin extends Component {
  constructor(props) {
    super(props)

    this._handleSubmit = this._handleSubmit.bind(this)
    this._handleOnChange = this._handleOnChange.bind(this)

    this.state = {
      email: '',
      password: '',
      error: {}
    }
  }

  _handleOnChange(e) {
    const { name, value } = e.target

    this.setState({
      [name]: value.trim()
    });
  }

  _handleSubmit(e) {
    e.preventDefault();
    clearToken();

    const { email, password } = this.state

    const data = {
      user: {
        login: email,
        password
      }
    }

    this.props.profileLogin(data).then((res) => {
      trackValues('stage', 'auth', {
        context: { validEmail: true, site_id: trackSiteId, userId: res.data.user.id },
      });
    });
  }

  render() {
    const { email, password } = this.state
    const { isFetching } = this.props;

    const disabled = !email || !password || isFetching;


    if (isFetching) {
      return <Loader absolute />
    }

    const errors = get(this.props.error, 'errors', [])

    return (
      <div className={baseStyles.animate_form}>
        <div className={baseStyles.content} key='login-intro'>
          <h2 className={classnames(baseStyles.text_large, baseStyles.break_text, baseStyles.lh_text, baseStyles.mb_10, baseStyles.centered)}>
            {LoginPageTitle}
          </h2>
          <p className={classnames(baseStyles.title_extra_small, baseStyles.centered, baseStyles.mb_20, baseStyles.text_light)}>
            {LoginPageSubTitle}
          </p>
        </div>

        <div className={baseStyles.form_styles} key='login-form'>

          <form onSubmit={this._handleSubmit} method="post" noValidate>
            <div className={baseStyles.form_field}>
              <div className={baseStyles.form_label_box}>
                <h4 className={baseStyles.form_label}>Your email</h4>
              </div>
              <Input type="email" placeholder="Enter your email" block name="email"
                onChange={this._handleOnChange} value={email} />
            </div>

            <div className={baseStyles.form_field}>
              <div className={baseStyles.form_label_box}>
                <h4 className={baseStyles.form_label}>Your password</h4>
              </div>
              <Input placeholder="Enter password" block name="password" type="password"
                onChange={this._handleOnChange} value={password} />
            </div>
            {errors.map((item, key) => (
              <div key={`essay-welcome-error-${key}`} className={classnames(baseStyles.text_danger, baseStyles.space_bottom)}>
                {item === 'authentication error' ? 'Invalid email or password' : item}
              </div>
            ))}

            <div className={baseStyles.form_field}>
              <Button type="submit" disabled={disabled} block>Login</Button>
            </div>
          </form>

          <div className={baseStyles.form_links}>
            <Link className={baseStyles.link_devider} to='/registration'>I don&apos;t have an account</Link>
            <Link to='/restore-password'>Forgot password</Link>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  error: state.profile.error,
  isFetching: state.profile.isFetching,
});

const mapDispatchToProps = dispatch => ({
  profileLogin: (data) => (dispatch(profileLogin(data))),
});

export default connect(mapStateToProps, mapDispatchToProps)(PageLogin);



// WEBPACK FOOTER //
// ./src/components/PageLogin.js